export default __webpack_public_path__ + "static/media/CNo.48-4.056f4c6a.jpg";